import validate from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_8425b33b527d0c201ab894d3252ee22f/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45jwt_45global from "/builds/bunuble/bunuble/bunuble/middleware/01.jwt.global.ts";
import manifest_45route_45rule from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_8425b33b527d0c201ab894d3252ee22f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45jwt_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/bunuble/bunuble/bunuble/middleware/auth.ts"),
  "tmp-redirect-from-index": () => import("/builds/bunuble/bunuble/bunuble/middleware/tmp-redirect-from-index.ts")
}